module.exports = __webpack_public_path__ + "static/media/smilingActive.5de35da1.svg";